import { AuthService } from 'app/_services/auth.service';
import { ErrorHandler } from 'app/_services/error-handler.factory';
import { StorageLocationResource } from 'app/_resources/storage-location.resource';
import * as angular from 'angular';
import { mgoAngularWizard, StorageBookingWizardContext } from '../custom';

class LngBookingWizardLocationCtrl implements ng.IController {
    wizardCtrl: mgoAngularWizard.Wizard<StorageBookingWizardContext>;
    form: ng.IFormController;

    isLoggedIn: boolean;
    locationList: StorageLocationDto[];
    selectedLocationName: string;

    loadingStorageLocations: boolean = true;

    constructor(
        private $location: ng.ILocationService,
        private authService: AuthService,
        private $localStorage: ngStorage.StorageService,
        private errorHandler: ErrorHandler,
        private storageLocationResource: StorageLocationResource
    ) {
        this.isLoggedIn = this.authService.getLoggedInUser() != null;
    }

    $onInit() {
        this.wizardCtrl.context.selectedLocation = null;

        if (this.isLoggedIn && this.$localStorage['lngBooking_step1']) {
            this.wizardCtrl.context.selectedLocation.refId =
                this.$localStorage['lngBooking_step1'].locationId;
            this.wizardCtrl.context.selectedFcfsOffer.id =
                this.$localStorage['lngBooking_step1'].offerId;
            this.wizardCtrl.goTo(1);
        }

        this.storageLocationResource
            .getAll(
                (res: StorageLocationDto[]) => (this.locationList = res),
                this.errorHandler
            )
            .$promise.finally(() => (this.loadingStorageLocations = false));
    }

    public setLocation(location: StorageLocationDto): void {
        this.form.entryName.$setDirty();
        this.wizardCtrl.context.selectedLocation = location;
        this.selectedLocationName = location.name;

        this.wizardCtrl.context.selectedFcfsOffer = null;
        this.wizardCtrl.context.storageFcfsRequest = null;

        this.storageLocationResource.getFcfsOffersForLocation(
            { id: this.wizardCtrl.context.selectedLocation.refId },
            (res: StorageFcfsOfferDto[]) =>
                this.form.entryName.$setValidity(
                    'pkpNoOfferAtLocation',
                    res.length > 0
                ),
            this.errorHandler
        );
    }

    public submit(form: ng.IFormController): boolean {
        if (!form.$valid) {
            return false;
        }
        this.wizardCtrl.next();
        return true;
    }
}

angular.module('app').component('pkpLngBookingWizardLocation', {
    controller: LngBookingWizardLocationCtrl,
    template:
        require('app/lng-booking-wizard/lng-booking-wizard-location.component.html'),
    require: {
        wizardCtrl: '^^wizard'
    },
    bindings: {}
});
